<template>
  <div>
    <header v-if="header">
      <div class="header-head">
        <div class="logo-diy">
          <img @click="GoHome" class="logo-head" src="@/assets/img/logo.png" alt="" />
        </div>
        <div>
          <div class="login-button-right">
            <!-- <el-link icon="el-icon-mobile-phone" :underline="false"
              >App</el-link
            > -->
            <div style="width: 30px"></div>
            <!-- <el-link :underline="false" @click="ClickSignIn">Sign In</el-link> -->
            <div v-if="username == ''" class="SingUp">
              <el-link :underline="false" @click="ClickSignIn">Sign In</el-link>
            </div>
            <div style="margin-right: 16px" v-else>
              <el-dropdown @command="handleCommand">
                <div class="el-dropdown-link">
                  <img v-if="userInfo.avatar" class="headImgUrl" :src="userInfo.avatar" alt="">
                  <div v-if="!userInfo.avatar" class="user-head-img">{{ headname }}</div>
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </div>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item icon="el-icon-user" command="1"
                    >Account Info</el-dropdown-item
                  >
                  <el-dropdown-item icon="el-icon-bank-card" command="2"
                    >Subscription</el-dropdown-item
                  >
                  <el-dropdown-item icon="el-icon-warning-outline" command="3"
                    >Log Out</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </div>
    </header>
    <slot></slot>
  </div>
</template>

<script>
import { getPath } from "@/utils/aes";
export default {
  name: "Framework",
  props: {
    header: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      username: "",
      userInfo: null,
      divided: true,
      headname:"",
    };
  },
  mounted() {
    if (localStorage.getItem("userInfo")) {
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
      this.username = this.userInfo.name;
      if (this.userInfo.name) {
        this.headname = this.userInfo.name.substring(0,1);
      }
    }
  },
  methods: {
    handleCommand(e) {
      if (e == "1") {
        this.$router.push({ path: `/userCenter/profile` });
      } else if (e == "2") {
        this.$router.push({ path: `/userCenter/vip` });
      } else if (e == "3") {
        localStorage.removeItem("token");
        localStorage.removeItem("userInfo");
        if (this.$route.path == "/home") {
          location.reload();
        } else {
          location.href = getPath("/home");
        }
      }
    },
    ClickSignIn() {
      location.href = getPath("/login");
    },
    GoHome() {
      if (this.$route.path == "/home") {
        location.reload();
      } else {
        location.href = getPath("/home");
      }
    },
  },
  created() {},
};
</script>

<style lang="less" scoped>
.header-head {
  height: 70px;
  width: 100%;
  background: linear-gradient(270deg, #9fc2ff 0%, #6000c1 100%);
  display: flex;
  justify-content: space-between;
  align-items: center;
  .logo-diy {
    .logo-head {
      height: 20px;
      width: 200px;
      margin-left: 50px;
      cursor: pointer;
    }
  }

  .login-button-right {
    display: flex;
    // width: 200px;
    justify-content: space-around;
    .el-link--default {
      color: #ffffff;
      font-size: 20px;
    }
    .SingUp {
      margin-right: 16px;
      width: 100px;
      height: 50px;
      border-radius: 10px;
      opacity: 1;

      /* 按钮颜色 */
      background: #4d52de;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
.headImgUrl {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.el-dropdown-link {
  display: flex;
  align-items: center;
  .user-head-img{
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #BC7935;
    color: #ffffff;
    font-size: 16px;
    text-align: center;
    line-height: 40px;
  }
}
.el-icon-arrow-down {
  font-size: 20px;
  color: #ffffff;
}
.el-dropdown-menu__item {
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
}
.el-dropdown-menu {
  background-color: #666666;
}
</style>
